import { type UserInfo } from '@/types';

import { normalizeStoredWorkspace } from './mapWorkspaceDetail';

/**
 * `quiz_user`(localStorage) 에서 복원한 값을 보정한다. idempotent.
 *
 * 저장소는 스키마 검증도 마이그레이션도 없어서 예전 배포가 남긴 JSON 이 그대로 돌아온다.
 * `workspace` 가 빠진 페이로드로 부팅한 사용자가 전역 CRM 동기화에서 크래시했다(QUIZ-APP-7YB).
 * 필드 존재만 보장하며 값의 타입까지 검증하지는 않는다.
 */
export const normalizeStoredUser = (
  user: UserInfo | null | undefined,
): UserInfo | null =>
  user
    ? { ...user, workspace: normalizeStoredWorkspace(user.workspace) }
    : null;
